export function QuantitySummary(actualQuantity: number, splitInTo: number): number[] {
  const valueNumber = Number(actualQuantity);
  const quantityNumber = Number(splitInTo);
  const valuePerItem = Math.floor(valueNumber / quantityNumber);
  const totalValueWithoutLeftOver = valuePerItem * quantityNumber;
  let valueLeftOver = Math.round(valueNumber - totalValueWithoutLeftOver);
  const output: number[] = [];

  for (let index = 0; index < splitInTo; index++) {
    output.push(valuePerItem);
  }

  // Split the left overs
  for (let index = 0; index < splitInTo; index++) {
    if (valueLeftOver > 0) {
      output[index] = output[index] + 1;
      valueLeftOver--;
    }
  }

  return output;
}
